import React, { useMemo } from "react";
import { mdiCheck } from "@mdi/js";
import Icon from "@mdi/react";

import { ColumnItemMap } from "..";
import styles from "./styles.scss";

const SharpIcon = require("public/icon/sharp-icon.png?sizes[]=20,sizes[]=40,sizes[]=60");

export interface InputColumnItem {
  name: string;
  key: string;
  column: number;
  isSharp?: boolean;
}

export interface InputColumnProps {
  title?: string;
  betType?: string;
  items: InputColumnItem[];
  columnItems: ColumnItemMap;
  onChangeSetting(settingId: number): void;
  className?: string;
}

const InputColumn = React.memo(
  ({ title, betType, items, columnItems, onChangeSetting, className }: InputColumnProps) => {
    const filteredItems: InputColumnItem[] = useMemo(() => {
      if (betType === "spread") {
        return items.filter((item) => item.key !== "currentSpread");
      } else if (betType === "moneyline") {
        return items.filter((item) => item.key !== "currentML");
      } else if (betType === "total") {
        return items.filter((item) => item.key !== "currentOU");
      } else {
        return items;
      }
    }, [items, betType]);
    return (
      <div className={`rotoql-input-column ${className || ""}`}>
        <div className="rotoql-input-column__text-title">{title ? title : ""}</div>
        {filteredItems.map((item: InputColumnItem) => (
          <div className="rotoql-input-column__item" key={item.name}>
            <div className="rotoql-input-column__pretty pretty p-icon p-fill p-curve p-bigger">
              <input
                type="checkbox"
                className={"rotoql-input-column__input"}
                checked={columnItems?.[item.column]?.selected ?? false}
                onChange={() => onChangeSetting(item.column)}
              />
              <div className="state p-primary rotoql-input-column__text">
                <Icon className="icon" path={mdiCheck} size="17px" color="#ffffff" />
                <label>{item.name}</label>
              </div>
            </div>
            {item.isSharp ? (
              <img
                src={SharpIcon.src}
                srcSet={SharpIcon.srcSet}
                alt="Sharp Tier Icon"
                className="rotoql-input-column__sharp-icon"
              />
            ) : null}
          </div>
        ))}
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
);

export default InputColumn;
